import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { LocationsPage } from './pages/LocationsPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { SignInPage } from './pages/SignInPage';
import { FleetServicesPage } from './pages/FleetServicesPage';
import { BecomePartnerPage } from './pages/BecomePartnerPage';
import { RequestInfoPage } from './pages/RequestInfoPage';
import { TireSalesPage } from './pages/services/TireSalesPage';
import { TireInstallationPage } from './pages/services/TireInstallationPage';
import { TireRotationPage } from './pages/services/TireRotationPage';
import { FlatTireRepairPage } from './pages/services/FlatTireRepairPage';
import { FreeTireChecksPage } from './pages/services/FreeTireChecksPage';
import { EmergencyRoadsidePage } from './pages/services/EmergencyRoadsidePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route element={<Layout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/services/tire-sales" element={<TireSalesPage data-id="element-9" />} data-id="element-8" />
          <Route path="/services/tire-installation" element={<TireInstallationPage data-id="element-11" />} data-id="element-10" />
          <Route path="/services/tire-rotation" element={<TireRotationPage data-id="element-13" />} data-id="element-12" />
          <Route path="/services/flat-tire-repair" element={<FlatTireRepairPage data-id="element-15" />} data-id="element-14" />
          <Route path="/services/free-tire-checks" element={<FreeTireChecksPage data-id="element-17" />} data-id="element-16" />
          <Route path="/services/emergency-roadside" element={<EmergencyRoadsidePage data-id="element-19" />} data-id="element-18" />
          <Route path="/locations" element={<LocationsPage data-id="element-21" />} data-id="element-20" />
          <Route path="/about" element={<AboutPage data-id="element-23" />} data-id="element-22" />
          <Route path="/contact" element={<ContactPage data-id="element-25" />} data-id="element-24" />
          <Route path="/reviews" element={<ReviewsPage data-id="element-27" />} data-id="element-26" />
          <Route path="/signin" element={<SignInPage data-id="element-29" />} data-id="element-28" />
          <Route path="/fleet-services" element={<FleetServicesPage data-id="element-31" />} data-id="element-30" />
          <Route path="/become-partner" element={<BecomePartnerPage data-id="element-33" />} data-id="element-32" />
          <Route path="/request-info" element={<RequestInfoPage data-id="element-35" />} data-id="element-34" />
        </Route>
      </Routes>
    </BrowserRouter>;
}